export const MasterMessage = {
    modules: {
        home: 'Home',
        bulkLoad: 'Cargue Masivo',
        cases: 'Casos',
        times: 'Tiempos',
        caseManagement: 'Gestión Casos',
        caseManager: 'Administración Casos',
        caseReport: 'Reportar Casos',
        caseClosure: 'Cierre Casos',
        caseCreation: 'Creación Casos',
        caseOTRS: 'Casos OTRS',
        usersCreation: 'Creación de usuarios',
        activityTimes: 'Reporte Tiempos',
        exportActivityTimes: 'Exporte Tiempos',
        weCallYouAdmin: 'Te Llamamos Admin',
        surveys: 'Encuestas',
        users: 'Usuarios',
        blokPages: 'Bloquear Páginas',
        chat: 'Chat',
        videoCall: 'Videollamada',
        weCallYou: 'Te llamamos',
        videoAtencion: 'Video Atención',
        commercialCrm: 'Crm Comercial',
        commercialCrmLoadBaseBP: 'Bases Brighpattern',
        commercialCrmLoadBaseGupshup: 'Bases Whatsapp',
        commercialCrmLoadBaseGupshupCustom: 'Bases Whatsapp Personalizado',
        commercialCrmUploadFolder: 'Subir Carpeta (S3)',
        wspTemplates: 'Whatsapp Template',
        voiceBlaster: 'Voice Blaster',
        ivr: 'IVR',
        ivrTypificationBase: 'Tipificaciones Base IVR',
    },
    auth: {
        login: {
            'AUTH-NO-SIGIN': 'Usuario o contraseña incorrecta',
            'AUTH-INACTIVE': 'Usuario inactivo',
            'AUTH-NO-CAPTCHA': 'ReCAPTCHA incorrecto',
            messageGeolocalizationError:
                'No se puedo obtener la geolocalización',
            messageGeolocalizationSignIn:
                'Necesitamos acceder a tu geolocalización para poder iniciar sesión',
        },
        register: {
            messageRegister: 'Registro creado exitosamente',
            messageErrorRegister: 'Se presento un error al crear el registro',
            messageErrorRegisterCode:
                'El código del usuario ya se encuentra registrado',
            messageErrorRegisterUserName:
                'El correo del usuario ya se encuentra registrado',
        },
        expirationToken: {
            title: 'Su sesión se cerró porque ha expirado',
            subTitle: 'EXPIRÓ LA SESIÓN',
            messsage: 'Debes iniciar sesión de nuevo para ingresar a On Time.',
        },
        noAccess: {
            title: '¡ Lo sentimos, no tienes permisos !',
            subTitle: 'SIN ACCESO',
            messsage:
                'Ponte en contacto con el administrador para obtener permisos.',
        },
        logout: {
            titleLogout: 'Cerrar Sesión',
            messageLogout: 'Está seguro que desea cerrar sesión',
        },
        chat: 'reCAPTCHA invalido.',
    },
    caseManagement: {
        titleList: 'Listado Gestión Casos',
    },
    bulkLoad: {
        titleList: 'Cargue Masivo',
        messageError: 'Se presento un error al crear el cargue masivo',
        titleModalLoading: 'Cargando Archivo',
        messageModalLoading: 'Se están cargando los registros del archivo',
    },
    usersCreation: {
        titleList: 'Cargue Masivo de Usuarios',
        messageError: 'Se presento un error al crear el cargue masivo',
        titleModalLoading: 'Cargando Archivo',
        messageModalLoading: 'Se están cargando los registros del archivo',
    },
    caseManager: {
        titleList: 'Listado Administración Casos',
        titleInfo: 'Info Registro',
        messageError: 'Se presento un error al asignar el cargue aleatorio',
        titleModalLoading: 'Cargando Asignaciones',
        messageModalLoading:
            'Se están cargando las asignaciones aletorio a los agentes',
        messageOneToOneOk: 'Se asignó el registro exitosamente',
        messageOneToOneError: 'Se presento un error al asignar el registro',
        messageManagementOk: 'Se guardo la gestión exitosamente',
        messageManagemenError: 'Se presento un error al guardar la gestión',
        'USER-ROL-INVALID': 'Este pérfil no tiene los permisos para consultar',
    },
    caseReport: {
        titleNew: 'Reportar Casos',
        messageError: 'Se presento un error al crear la persona',
        messageUpdateError: 'Se presento un error al actualizar la persona',
        messageErrorTipification:
            'Se presento un error al crear la tipificación',
        titleModal: 'Histórico',
    },
    caseClosure: {
        titleList: 'Listado Cierre Casos',
        titleNew: 'Importar Casos',
        titleModalLoading: 'Cargando Archivo',
        messageModalLoading: 'Se están cargando los registros del archivo',
        messageError: 'Se presento un error al crear el cargue masivo',
    },
    caseCreation: {
        titleList: 'Listado Creación Casos Pendientes',
        titleNew: 'Importar Casos',
        titleModalLoading: 'Cargando Archivo',
        messageModalLoading: 'Se están cargando los registros del archivo',
        messageError: 'Se presento un error al crear el cargue masivo',
        messageOkExport: 'El exporte fue descargado exitosamente',
        messageErrorExport: 'Se presento un error al descargar el exporte',
    },
    activityTimes: {
        titleList: 'Listado Reporte Tiempos',
        titleNew: 'Agregar Reporte Tiempo',
        messageNew: 'El reporte de tiempo fue creado exitosamente',
        messageError: 'Se presento un error al crear el reporte de tiempo',
    },
    exportActivityTimes: {
        titleList: 'Exporte Reporte Tiempos',
        messageOk: 'El exporte fue descargado exitosamente',
        messageError: 'Se presento un error al descargar el exporte',
    },
    weCallYouAdmin: {
        titleList: 'Administrador De Te Llamamos Admin',
        titleDelete: 'Eliminar Franja',
        messageDelete: 'Está seguro que desea eliminar la franja',
        messageDeleteOk: 'Se elimino la franja exitosamente',
        modalConfigWeCallYou: {
            titleNew: 'Agregar Configuración Franjas',
            messageNew: 'La configuración fue creada exitosamente',
            titleEdit: 'Editar Configuración Franjas',
        },
        modalTimeFrameConfig: {
            titleNew: 'Agregar Franjas',
            messageNew: 'La franja fue creada exitosamente',
            titleEdit: 'Editar Franjas',
            messageEdit: 'La franja fue actualizada exitosamente',
        },
    },
    surveys: {
        titleList: 'Listado Encuestas',
        'SURVEY-ERROR-FIND':
            'Se presento un error al cargar el listado de encuestas',
        titleNew: 'Agregar Encuesta',
        'SURVEY-DUPLICATED': 'El código de la encuesta ya existe',
        'SURVEY-NEW-FAIL': 'Se presento un error al crear la encuesta',
        'SURVEY-NOT-FOUND': 'No se encontro la encuesta',
        titleEdit: 'Editar Encuesta',
        messageEdit: 'La encuesta fue actualizada exitosamente',
        'SURVEY-ERROR-UPDATE': 'Se presento un error al actualizar la encuesta',
        titleInactive: 'Deshabilitar Encuesta',
        messageInactive: 'Está seguro que desea deshabilitar la encuesta',
        messageInactiveOk: 'Se deshabilito la encuesta exitosamente',
        'SURVEY-ERROR-DELETE':
            'Se presento un error al deshabilitar la encuesta',
        questions: {
            'QUESTION-ERROR-FIND':
                'Se presento un error al cargar el listado  de encuestas',
            titleNew: 'Agregar Pregunta',
            messageNew: 'La pregunta fue creada exitosamente',
            'QUESTION-ERROR-SAVE': 'Se presento un error al crear la pregunta',
            'QUESTION-DUPLICATED': 'La pregunta ya existe',
            'QUESTION-NOT-FOUND': 'No se encontro la pregunta',
            titleEdit: 'Editar Pregunta',
            messageEdit: 'La pregunta fue actualizada exitosamente',
            'QUESTION-ERROR-UPDATE':
                'Se presento un error al actualizar la pregunta',
            titleInactive: 'Deshabilitar Pregunta',
            messageInactive: 'Está seguro que desea deshabilitar la pregunta',
            messageInactiveOk: 'Se deshabilito la pregunta exitosamente',
            'QUESTION-ERROR-DELETE':
                'Se presento un error al deshabilitar la pregunta',
        },
        range: {
            titleNew: 'Agregar Rango',
            messageNew: 'El rango fue creada exitosamente',
            'ANSWER-ERROR-SAVE': 'Se presento un error al crear el rango',
            'ANSWER-ERROR-FIND':
                'Se presento un error en la busqueda del rango',
            'ANSWER-NOT-FOUND': 'No se encontro el rango',
            titleEdit: 'Editar Rango',
            messageEdit: 'El rango fue actualizado exitosamente',
            'ANSWER-ERROR-UPDATE':
                'Se presento un error al actualizar el rango',
        },
        answer: {
            titleNew: 'Agregar Respuesta',
            'ANSWER-ERROR-FIND':
                'Se presento un error en la busqueda de la respuesta',
            messageNew: 'La respuesta fue creada exitosamente',
            messageNewError: 'Se presento un error al crear la respuesta',
            titleEdit: 'Editar Respuesta',
            messageEdit: 'La respuesta fue actualizada exitosamente',
            messageEditError: 'Se presento un error al actualizar la respuesta',
            titleDelete: 'Deshabilitar Respuesta',
            messageInactive: 'Está seguro que desea deshabilitar la respuesta',
        },
    },
    users: {
        titleList: 'Listado Usuarios',
        titleNew: 'Agregar Usuario',
        messageNew: 'El usuario fue creado exitosamente',
        messageNewError: 'Se presento un error al crear el usuario',
        titleEdit: 'Editar Usuario',
        messageEdit: 'El usuario fue actualizado exitosamente',
        messageEditError: 'Se presento un error al actualizar el usuario',
        messageErrorCode: 'El código del usuario ya existe',
        messageErrorEmail: 'El correo del usuario ya existe',
        titleInactive: 'Deshabilitar Usuario',
        messageInactive: 'Está seguro que desea deshabilitar el usuario',
        messageInactiveOk: 'Se deshabilito el usuario exitosamente',
        messageInactiveError: 'Se presento un error al deshabilitar el usuario',
    },
    wspTemplate: {
        titleList: 'Listado Template',
        titleNew: 'Agregar Template',
        messageNew: 'El Template fue creado exitosamente',
        messageNewError: 'Se presento un error al crear el Template',
        titleEdit: 'Editar Template',
        messageEdit: 'El Template fue actualizado exitosamente',
        messageEditError: 'Se presento un error al actualizar el Template',
        titleInactive: 'Deshabilitar Template',
        messageInactive: 'Está seguro que desea deshabilitar el Template',
        messageInactiveOk: 'Se deshabilito el Template exitosamente',
        messageInactiveError:
            'Se presento un error al deshabilitar el Template',
    },
    blokPages: {
        titleList: 'Listado Páginas Bloqueadas',
        titleNew: 'Agregar Página Bloqueada',
        messageNew: 'La página bloqueada fue creada exitosamente',
        messageNewError: 'Se presento un error al crear la página bloqueada',
        titleEdit: 'Editar Página Bloqueada',
        messageEditOk: 'La página bloqueada fue actualizada exitosamente',
        messageEditError:
            'Se presento un error al actualizar la página bloqueada',
        titleDelete: 'Eliminar Página Bloqueada',
        messageDelete: 'Está seguro que desea eliminar la página bloqueada',
        messageDeleteOk: 'Se elimino la página bloqueada exitosamente',
        messageDeleteError:
            'Se presento un error al eliminar la página bloqueada',
    },
    pageNotFound: {
        title: '¡Ups! Página no encontrada',
        subTitle: 'Page not found',
        messsage: '¡Lo sentimos pero no se encontró la página que solicitas!',
    },
    commercialCrm: {
        loadBase: {
            titleListBP: 'Cargue de Archivo Base Brightpattern',
            titleListWhatsapp: 'Cargue de Archivo Base Whatsapp',
            titleListWhatsappCustom: 'Cargue de Archivo Base Whatsapp Personalizado',
            messageError: 'Se presento un error al cargar la base',
            titleModalLoading: 'Cargando Archivo Base',
            titleModalLoadingWhatsapp: 'Cargando Archivo Base Whatsapp',
            titleModalLoadingWhatsappCustom:
                'Cargando Archivo Base Whatsapp Personalizado',
            messageModalLoading: 'Se están cargando los registros del archivo',
        },
        uploadFolder: {
            title: 'Cargue de Carpeta a S3',
            messageError: 'Se presentó un error al subir los archivos',
            messageOk: 'Los archivos se subieron exitosamente',
        },
    },
    voiceBlaster: {
        titleEdit: 'Editar Voice Blaster',
        messageEdit: 'El mensaje fue actualizado exitosamente',
        messageEditError: 'Se presentó un error al actualizar el mensaje',
        'ERROR-FIND': 'Se presentó un error al obtener los mensajes',
        'NOT-FOUND': 'No se encontró el mensaje',
    },
    ivr: {
        titleEdit: 'Editar IVR',
        messageEdit: 'El mensaje fue actualizado exitosamente',
        messageError: 'Se presentó un error al actualizar el mensaje',
        'ERROR-FIND': 'Se presentó un error al obtener los mensajes',
        'NOT-FOUND': 'No se encontró el mensaje',
    },
    ivrTypificationBase: {
        titleList: 'Listado Tipificaciones Base IVR',
        titleNew: 'Importar Tipificaciones Base IVR',
        titleModalLoading: 'Cargando Archivo',
        messageModalLoading: 'Se están cargando los registros del archivo',
        messageError: 'Se presento un error al crear el cargue masivo',
        messageOkTemplate: 'El template fue descargado exitosamente',
        messageErrorTemplate:
            'Se presento un error al descargar el template base',
        helpTourButton: 'Guía rápida',
        syncButton: 'Cargar a CRMIcetex',
        syncConfirmTitle: '¿Seguro que desea cargar la data a CRMIcetex?',
        syncConfirmMessage:
            'Verifica con anterioridad que hayas subido los archivos correctos y que no se hayan cargado datos duplicados.',
        syncSuccessMessage:
            'La sincronización de tipificaciones hacia CRMIcetex se ejecutó exitosamente.',
        syncErrorMessage:
            'Se present? un error al sincronizar la data hacia CRMIcetex.',
        importInfoNotice:
            'Al importar un archivo masivo, los registros anteriores del mismo tipo de tipificación se desactivarán y dejarán de aplicarse. Solo permanecerán activos los datos de la última carga de ese tipo.',
        importSuccessDetail:
            'La importación se aplicó correctamente. Los registros previos del mismo tipo de tipificación fueron desactivados; la tabla muestra ya la información vigente.',
    },
};
